/**
 * 用户信息
 */
const userinfo = {
  state: {
    userinfo: JSON.parse(localStorage.getItem('xw_userinfo')) || {},
  },
  mutations: {
    USER_INFO(state, info) {
      state.userinfo = info
    },
  },
  actions: {
    userinfo: ({ commit }, info) => {
      commit('USER_INFO', info)
    }
  },
  getters: {
    userinfo: state => state.userinfo
  }
}

export default userinfo